<template>
    <div class="main">
        <Transition appear name="fade">
            <HeaderComponent
                    style="margin-top:100px;"
                    :text="$t('text.reset_password')"
                    backgroundColor="#fff"
                />
        </Transition>
        <Transition appear name="fade">        
            
        </Transition>
            
        <Transition appear name="fade">
            <div class="body-container">
                
                <div v-if="loading" class="loader-container" style="text-align: center; margin-top:80px;">
                    <b-spinner
                        variant="dark"
                        label="Spinning"
                        class="login-loader"
                    ></b-spinner>
                </div>
                <p v-if="step==0 && !loading">{{ $t('text.forgot_password_text') }} <a class="link-button" @click="step=1">{{ $t('text.click_here') }}</a> </p>
                <b-form @submit="onSubmit" v-if="!loading">
                    <b-form-group v-if="step==0" :label="$t('text.email_address')">
                        <b-form-input
                        v-model="form.email"
                        type="email"
                        :placeholder="$t('text.enter_email')"
                        required
                        ></b-form-input>
                    </b-form-group>
                    
                    <b-form-group v-if="step==1" :label="$t('text.reset_code')" label-for="input-1">
                        <b-form-input
                        v-model="form.reset_code"
                        :placeholder="$t('text.enter_reset_code')"
                        required
                        ></b-form-input>
                    </b-form-group>

                    <b-form-group v-if="step==1" id="input-group-5" :label="$t('text.password')" label-for="input-4">
                        <b-form-input
                        id="input-5"
                        v-model="form.password"
                        type="password"
                        :placeholder="$t('text.enter_password')"
                        ></b-form-input>
                    </b-form-group>

                    <b-form-group v-if="step==1" id="input-group-6" :label="$t('text.repeat_password')" label-for="input-4">
                        <b-form-input
                        id="input-6"
                        v-model="form.repeat_password"
                        type="password"
                        :placeholder="$t('text.repeat_password')"
                        ></b-form-input>
                        <b-form-invalid-feedback :state="passwordValidation">
                            {{ $t('text.passwords_not_match') }}
                        </b-form-invalid-feedback>
                    </b-form-group>

                    <b-button v-if="step==0" :disabled="!enableSubmitButton" type="submit" variant="primary">{{ $t('text.send_code') }}</b-button>
                    <b-button v-if="step==1" :disabled="!enableSubmitButton" type="submit" variant="primary">{{ $t('text.reset_password') }}</b-button>
                    <a v-if="step==0" style="float:right" @click="backButtonPressed()" class="link-button">{{ $t('text.login') }}</a>
                    <a v-if="step==1" style="float:right" @click="backButtonPressed()" class="link-button">{{ $t('text.back') }}</a>
                </b-form>
            </div>
        </Transition>
    </div>
</template>

<script>
import HeaderComponent from "../components/HeaderComponent.vue";
import UserApiService from "../../services/user_api_service";

export default {
    name: "ResetPasswordPage",
    components: {
        HeaderComponent,
    },
    data() {
        return {
            loading: false,
            step: 0,
            form: {
                email: '',
                reset_code: '',
                password: '',
                repeat_password: '',
            },
        };
    },
    computed: {
        enableSubmitButton() {
            if (this.step == 0) {
                return this.form.email
            } else {
                return (
                    this.form.reset_code &&
                    this.form.password &&
                    this.form.repeat_password &&
                    this.form.password == this.form.repeat_password
                )
            }
        },
        passwordValidation() {
            return (this.form.password == this.form.repeat_password) 
        },
    },
    methods: {
        async requestResetCode() {
            this.loading = true;
            var payload = {email: this.form.email}
            try {
                await UserApiService.request_password_reset(payload);
                this.loading = false;
                this.step == 1;
            } catch (error) {
                this.$bvModal.msgBoxOk(error.response.data[0], {okVariant: 'danger'})
                localStorage.clear();
                this.loading = false;
            }
        },
        async resetPassword() {
            this.loading = true;
            var payload = {password: this.form.password}
            try {
                await UserApiService.reset_password(this.form.reset_code, payload);
                this.loading = false;
                this.$bvModal.msgBoxOk(this.$t('text.password_has_been_reset'))
                .then(() => {
                    this.$router.push("/login");
                })
            } catch (error) {
                this.$bvModal.msgBoxOk(error.response.data[0], {okVariant: 'danger'})
                localStorage.clear();
                this.loading = false;
            }
        },
        backButtonPressed() {
            if (this.step==0) {
                this.$router.push("/login");
            } else {
                this.step = 0
            }
        },
        onSubmit(event) {
            event.preventDefault()
            if (this.step == 0) {
                this.requestResetCode()
            } else {
                this.resetPassword()
            }
            
        },
        makeToast(variant = null, title, body) {
            this.$bvToast.toast(body, {
                title: title,
                toaster: "b-toaster-top-center",
                variant: variant,
                solid: true
            });
        },
    },
    mounted() {
        if (this.$route.query.code) {
            this.step=1;
            this.form.reset_code = this.$route.query.code;
        }
    }
};
</script>

<style scoped>
.main {
  height: 100%;
  background-color: #fff;
}

.body-container {
    text-align: left;
    margin: auto;

    padding-bottom: 100px;
    padding-left: 30px;
    padding-right: 30px;

    max-width: 860px;
}

.submit-button {
    float:right;
}

.link-button {
    color: #007bff;
}
</style>
